import React, { useState, useMemo } from "react";
import { toast } from "sonner";
import { filterAndSort, sortArr, money } from "@/lib/helpers";
import { exportExcel, exportPDF } from "@/lib/exports";
import PaginationBar from "@/components/PaginationBar";

const blank = { codigo: "", nombre: "", descripcion: "", precio: 0, stock: 0 };

export default function Articulos({ state, upsert, remove }) {
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState({ field: "nombre", dir: 1 });
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(blank);
  const [skip, setSkip] = useState(0);
  const [limit, setLimit] = useState(25);

  const toggleSort = (field) =>
    setSort((s) => (s.field === field ? { field, dir: -s.dir } : { field, dir: 1 }));

  const allRows = useMemo(
    () => filterAndSort(state.articulos, search, sort, state),
    [state.articulos, search, sort, state]
  );
  const pagedRows = allRows.slice(skip, skip + limit);

  const openModal = (row = null) => {
    setForm(row ? { ...blank, ...row } : { ...blank });
    setModal(true);
  };

  const save = async (e) => {
    e.preventDefault();
    await upsert("articulos", {
      ...form,
      precio: +form.precio || 0,
      stock: +form.stock || 0,
    });
    toast.success("Guardado");
    setModal(false);
  };

  return (
    <section className="space-y-5">
      <div className="flex flex-wrap gap-2 items-center">
        <input className="input max-w-xs" placeholder="Buscar artículo..."
               value={search} onChange={(e) => setSearch(e.target.value)}
               data-testid="search-articulos"/>
        <div className="flex-1"/>
        <button className="btn btn-ghost" onClick={() => exportExcel("articulos", state) || toast.error("Sin datos")}>Excel</button>
        <button className="btn btn-ghost" onClick={() => exportPDF("articulos", state) || toast.error("Sin datos")}>PDF</button>
        <button className="btn btn-primary" onClick={() => openModal()} data-testid="btn-new-articulo">+ Nuevo artículo</button>
      </div>

      <div className="card overflow-hidden">
        <table className="data">
          <thead><tr>
            {["codigo", "nombre", "descripcion", "precio", "stock"].map((f) => (
              <th key={f} className={`sortable ${f === "precio" || f === "stock" ? "text-right " : ""}${sort.field === f ? "active" : ""}`}
                  onClick={() => toggleSort(f)}>
                {({codigo:"Código",nombre:"Nombre",descripcion:"Descripción",precio:"Precio",stock:"Stock"})[f]}
                <span className="arr">{sortArr(sort, f)}</span>
              </th>
            ))}
            <th/>
          </tr></thead>
          <tbody>
            {pagedRows.map((a) => (
              <tr key={a.id}>
                <td className="font-mono text-xs">{a.codigo}</td>
                <td className="font-semibold">{a.nombre}</td>
                <td className="text-slate-600">{a.descripcion}</td>
                <td className="text-right font-semibold">{money(a.precio)}</td>
                <td className="text-right">{a.stock}</td>
                <td className="text-right whitespace-nowrap">
                  <button className="btn btn-ghost !py-1 !px-2" onClick={() => openModal(a)}>Editar</button>
                  <button className="btn btn-danger !py-1 !px-2" onClick={() => remove("articulos", a.id)}>✕</button>
                </td>
              </tr>
            ))}
            {allRows.length === 0 && (
              <tr><td colSpan="6" className="text-center text-slate-400 py-6">No hay artículos</td></tr>
            )}
          </tbody>
        </table>
        <PaginationBar
          total={allRows.length}
          skip={skip}
          limit={limit}
          onSkipChange={setSkip}
          onLimitChange={setLimit}
        />
      </div>

      {modal && (
        <div className="modal-backdrop">
          <div className="modal p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="font-bold text-lg">{form.id ? "Editar" : "Nuevo"} artículo</h3>
              <button onClick={() => setModal(false)} className="text-slate-400 hover:text-slate-700 text-2xl">✕</button>
            </div>
            <form onSubmit={save} className="grid md:grid-cols-2 gap-4">
              <div><label className="label">Código</label>
                <input className="input" value={form.codigo || ""} onChange={(e) => setForm({ ...form, codigo: e.target.value })}/></div>
              <div><label className="label">Nombre *</label>
                <input className="input" required value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} data-testid="articulo-nombre"/></div>
              <div className="md:col-span-2"><label className="label">Descripción</label>
                <input className="input" value={form.descripcion || ""} onChange={(e) => setForm({ ...form, descripcion: e.target.value })}/></div>
              <div><label className="label">Precio (€) *</label>
                <input className="input" type="number" step="0.01" required value={form.precio} onChange={(e) => setForm({ ...form, precio: e.target.value })} data-testid="articulo-precio"/></div>
              <div><label className="label">Stock</label>
                <input className="input" type="number" value={form.stock} onChange={(e) => setForm({ ...form, stock: e.target.value })}/></div>
              <div className="md:col-span-2 flex justify-end gap-2 pt-2">
                <button type="button" className="btn btn-ghost" onClick={() => setModal(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" data-testid="articulo-save">Guardar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </section>
  );
}
